import {jwtDecode} from "jwt-decode";

export const isTokenValid = (token) => {
    try {
        const decodedToken = jwtDecode(token);
        // "exp" è in secondi
        return decodedToken.exp * 1000 > Date.now();
    } catch (error) {
        return false
    }
}